export function numberOfDigits (val) {
  if (val === undefined || val === null) {
    return 0
  }
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}



// WEBPACK FOOTER //
// ./src/js/filters.js